 
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { BusinessSales } from '../types/business.type';
import { useAppDispatch, useAppSelector } from './store';
import { BusinessApi } from '../api';
import { currentMonthStart, now } from '../utils';

type SalesState = BusinessSales & {
  loading: boolean;
  failed: boolean;
};

export const salesSlice = createSlice({
  name: 'sales',
  initialState: {
    loading: true,
    failed: false,
    balance: 0,
    sales: 0,
    profit: 0,
    count: 0,
    transactions: [],
    transactionsByProduct: []
  } as SalesState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setFailed(state, action: PayloadAction<boolean>) {
      state.failed = action.payload;
    },
    setData(state, action: PayloadAction<BusinessSales>) {
      return { ...state, ...action.payload };
    }
  }
});

export function useSales() {

  const dispatch = useAppDispatch();
  const state = useAppSelector(state => state.sales);

  async function fetch(start: Date = currentMonthStart(), end: Date = now(), period: 'day' | 'month' = 'day') {

    try {

      dispatch(salesSlice.actions.setLoading(true));
      dispatch(salesSlice.actions.setFailed(false));
  
      const salesData = await BusinessApi.getSales(start, end, period);
  
      dispatch(salesSlice.actions.setData(salesData));
      dispatch(salesSlice.actions.setLoading(false));

    } catch {

      dispatch(salesSlice.actions.setFailed(true));
      dispatch(salesSlice.actions.setLoading(false));
    }
  }

  return {
    ...state,
    fetch
  };
}
